const utils = require("Sources/utils/utils");
const LanguageManager = require("Sources/services/language-manager");
const DialogTemplate = require("Sources/templates/dialog.template");

let dialog = {};

(function(Dialog)
{
    Dialog.showMessageDialog = function(options)
    {
        let cancelText = undefined;
        let confirmText = LanguageManager.getValueForKey("modal.buttons.ok");

        if (options.confirmText !== undefined)
        {
            confirmText = LanguageManager.getValueForKey(options.confirmText);
        }

        if (options.cancelText !== undefined)
        {
            cancelText = LanguageManager.getValueForKey(options.cancelText);
        }

        let messageDialog = new DialogTemplate({
            title: LanguageManager.getValueForKey(options.title),
            dialogContent: LanguageManager.getValueForKey(options.message),
            cancelText: cancelText,
            confirmText: confirmText,
            disposable: options.disposable,
            extraModalContentClass: options.extraModalContentClass,
            dialogId: options.dialogId,
            onConfirm: function()
            {
                messageDialog.destroy();

                if (utils.isFunction(options.onConfirm))
                {
                    options.onConfirm();
                }
            },
            onCancel: function()
            {
                messageDialog.destroy();
            },
            onDispose: function()
            {
                messageDialog.destroy();

                if (utils.isFunction(options.onDispose))
                {
                    options.onDispose();
                }
            }
        });

        messageDialog.show();

        return messageDialog;
    };

    Dialog.showOkCancelDialog = function(options)
    {
        let okCancelDialog = new DialogTemplate({
            title: LanguageManager.getValueForKey(options.title),
            dialogContent: LanguageManager.getValueForKey(options.message),
            confirmText: LanguageManager.getValueForKey("modal.buttons.ok"),
            cancelText: LanguageManager.getValueForKey("modal.buttons.cancel"),
            disposable: options.disposable,
            onConfirm: function()
            {
                okCancelDialog.destroy();

                if (utils.isFunction(options.onOk))
                {
                    options.onOk();
                }
            },
            onCancel: function()
            {
                okCancelDialog.destroy();

                if (utils.isFunction(options.onCancel))
                {
                    options.onCancel();
                }
            },
            onDispose: function()
            {
                okCancelDialog.destroy();

                if (utils.isFunction(options.onDispose))
                {
                    options.onDispose();
                }
            }
        });

        okCancelDialog.show();

        return okCancelDialog;
    };

    Dialog.showYesNoDialog = function(options)
    {
        let yesNoDialog = new DialogTemplate({
            title: LanguageManager.getValueForKey(options.title),
            dialogContent: LanguageManager.getValueForKey(options.message),
            confirmText: LanguageManager.getValueForKey("modal.buttons.yes"),
            cancelText: LanguageManager.getValueForKey("modal.buttons.no"),
            disposable: options.disposable,
            onConfirm: function()
            {
                yesNoDialog.destroy();

                if (utils.isFunction(options.onYes))
                {
                    options.onYes();
                }
            },
            onCancel: function()
            {
                yesNoDialog.destroy();

                if (utils.isFunction(options.onNo))
                {
                    options.onNo();
                }
            },
            onDispose: function()
            {
                yesNoDialog.destroy();

                if (utils.isFunction(options.onDispose))
                {
                    options.onDispose();
                }
            }
        });

        yesNoDialog.show();

        return yesNoDialog;
    };
}(dialog));

module.exports = dialog;



// WEBPACK FOOTER //
// ./app/js/utils/modal.js